// Budget sheet maths, the same rules the server uses when it saves (it recalculates the stored totals).
export const GROUP_KINDS = {
    qr: { label: 'Qty × unit cost', columns: ['qty', 'rate'] },
    dpr: { label: 'Days × persons × rate', columns: ['days', 'persons', 'rate'] },
};

export const COLUMN_LABEL = { qty: 'Qty', days: 'Days', persons: 'Persons', rate: 'Rate (₹)' };

const n = (v) => (Number.isFinite(Number(v)) && Number(v) > 0 ? Number(v) : 0);

export const rowAmount = (r, kind = 'qr') => (kind === 'dpr' ? n(r.days) * n(r.persons) * n(r.rate) : n(r.qty) * n(r.rate));

export const emptyRow = (kind = 'qr') => (kind === 'dpr' ? { name: '', days: '', persons: '', rate: '' } : { name: '', qty: '', rate: '' });

export const sheetTotals = (lines) => {
    const revenue = (lines.revenue || []).reduce((s, r) => s + rowAmount(r), 0);
    const byGroup = (lines.groups || []).map(g => ({ title: g.title, amount: g.rows.reduce((s, r) => s + rowAmount(r, g.kind), 0) }));
    const expenses = byGroup.reduce((s, g) => s + g.amount, 0);
    const profit = revenue - expenses;
    return { revenue, expenses, profit, margin: revenue > 0 ? Math.round((profit / revenue) * 1000) / 10 : null, by_group: byGroup };
};

export const inr = (v) => `₹${Math.round(Number(v) || 0).toLocaleString('en-IN')}`;

export const STARTER_GROUPS = [
    { title: 'Materials & equipment', kind: 'qr' },
    { title: 'Manpower', kind: 'dpr' },
    { title: 'Travel & logistics', kind: 'qr' },
];
